"use strict"

const angular = require("angular");

angular
    .module("Agnes")
    .factory("$addressLookup", [
        "$q",
        function ($q) {
            var addressLookup = {};

            addressLookup.lookup = function (text) {
                var result = $q.defer();
                var service = new window.google.maps.places.AutocompleteService();
                service.getQueryPredictions({
                    input: text,
                    types: ["geocode"]
                }, function (predictions, status) {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                        result.resolve(predictions);
                    } else if (status === window.google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                        result.resolve([{}]);
                    } else {
                        result.reject();
                    }
                });
                return result.promise;
            };

            addressLookup.detail = function (placeId) {
                var result = $q.defer();
                var service = new window.google.maps.places.PlacesService(document.getElementById("map"));
                service.getDetails({
                    placeId: placeId
                }, function (place, status) {
                    if (status === window.google.maps.places.PlacesServiceStatus.OK) {
                        result.resolve(place);
                    } else {
                        result.reject();
                    }
                });
                return result.promise;
            };

            return addressLookup;
        }
    ]);